import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';
import useHiddenWalletAddress from '~/core/composables/useHiddenWalletAddress';
import type { Props as IconProps } from '~/core/components/base/image/SvgThemedIcon.vue';
import { RANKS_ORDER } from '~/constants/constants';

interface Props {
    avatarSize?: 'm' | 'l' | 'xl' | 's' | 'm-h' | 'l-h' | 'xl-h' | 's-h' | 'm-w' | 'l-w' | 'xl-w' | 's-w',
    avatarUsernameGap?: string;
    username: string;
    usernameCopiable?: boolean;
    walletAddress: string;
    walletAddressCopiable?: boolean;
    showAddress?: boolean;
    clickable?: boolean;
    clickableIcon?: IconProps;
    whitRankIcon?:boolean;
    currentRankName?:string;
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
    avatarSize: { default: 'm' },
    avatarUsernameGap: { default: 'var(--spacing-xl)' },
    username: null,
    usernameCopiable: { type: Boolean, default: false },
    walletAddress: null,
    walletAddressCopiable: { type: Boolean, default: true },
    showAddress: { type: Boolean, default: true },
    clickable: { type: Boolean, default: false },
    clickableIcon: { default: () => ({
        name: 'more-right',
        path: 'arrows',
        color: 'neutral-icons-default',
    }) },
    whitRankIcon: { type: Boolean, default: false },
    currentRankName: null
  },
  setup(__props: any) {

const props = __props as { avatarSize: 'm' | 'l' | 'xl' | 's' | 'm-h' | 'l-h' | 'xl-h' | 's-h' | 'm-w' | 'l-w' | 'xl-w' | 's-w', avatarUsernameGap: string, username: string, usernameCopiable: boolean, walletAddress: string, walletAddressCopiable: boolean, showAddress: boolean, clickable: boolean, clickableIcon: IconProps, whitRankIcon:boolean, currentRankName?:string };

;



const {
    avatarSize,
    username,
    walletAddress,
    avatarUsernameGap,
    usernameCopiable,
    walletAddressCopiable,
    showAddress,
    whitRankIcon,
    currentRankName,
} = toRefs(props);
const hiddenAddress = useHiddenWalletAddress(walletAddress);

return { __sfc: true,props, avatarSize, username, walletAddress, avatarUsernameGap, usernameCopiable, walletAddressCopiable, showAddress, whitRankIcon, currentRankName, hiddenAddress, RANKS_ORDER }
}

})